import { startAnalytics } from "./analytics.js";
startAnalytics().catch(() => {
  /* Analytics must never prevent opening a journal. */
});
